import { useCallback } from 'react';
import useWorkOrders, {
  WorkOrderDetails
} from 'screens/Applications&WorkOrders/WorkOrders/Hooks/useWorkOrders';
import useQuery, { QueryKey } from 'hooks/useQuery';
import { CancelToken } from 'axios';

const useWorkOrderDetails = (workOrderId: string | null) => {
  const { getWorkOrder } = useWorkOrders();

  const queryFn = useCallback(
    (id: QueryKey, cancelToken?: CancelToken) => {
      if (!id || typeof id !== 'string') {
        throw new Error('Work order ID is required');
      }
      return getWorkOrder(id, cancelToken);
    },
    [getWorkOrder]
  );

  const { data, errors, isLoading, refreshCache, refetch } = useQuery<
    WorkOrderDetails
  >(workOrderId, queryFn, {
    cacheKeyPrefix: 'workOrder',
    cacheTTL: 0 // No caching for work order details
  });

  return {
    workOrderDetails: data,
    errors,
    isLoading,
    refreshCache,
    refetch
  };
};

export default useWorkOrderDetails;
